import { RootState } from '../../../../rootReducer';

export const palletTemplateSelector = (state: RootState) => state.templatesModuleReducer.PalletTemplateReducer;
